import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { OccasionType, UserOccasions } from '@csp/csp-common-model';
import { OccasionV1 } from '@csp/dmdp-api-user-dto';

const getUserOccasions = (occasions: OccasionV1[]): UserOccasions => {
  const inviteOccasion = occasions.find(occasion => occasion.type === OccasionType.INVITE);
  const trainingOccasion = occasions.find(occasion => occasion.type === OccasionType.TRAINING);

  return {
    inviteTime: inviteOccasion ? ZonedDateTimeFactory.fromZonedDateTimeString(inviteOccasion.localTime) : undefined,
    trainingDate: trainingOccasion
      ? ZonedDateTimeFactory.fromZonedDateTimeString(trainingOccasion.localTime)
      : undefined,
  };
};

export const UserOccasionService = {
  getUserOccasions,
};
